import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class SmartPowerStageAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVin = 0.6;
		this.normIo = 3;
		this.normFsw = 0.7;

		this.rankVin = 0;
		this.rankIo = 0;
		this.rankFsw = 0;

		this.weightVin = 0.15;
		this.weightIo = 0.15;
		this.weightFsw = 0.2;

		this.rVin = 0;
		this.rIo = 0;
		this.rFsw = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log('partNumber,part_Vin,rVin,rankVin,part_Io,rIo,rankIo,part_Fsw,rFsw,rankFsw,feRank');
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		//---------------------------------------------Reverse voltage  VR Min (V)---------------------------------------------

		[this.rankVin, this.rVin] = this.calculateRankSingleSliderGTE(CIDS.V_IN_TYP, product, this.normVin);

		//---------------------------------------------Forward current  IF Max (A)---------------------------------------------

		[this.rankIo, this.rIo] = this.calculateRankSingleSliderGTE(CIDS.I_OUT_MAX, product, this.normIo);

		//---------------------------------------------Reverse current  IR Max (µA)---------------------------------------------

		[this.rankFsw, this.rFsw] = this.calculateRankSingleSliderGTE(CIDS.SWITCHING_FREQUENCY_MAX, product, this.normFsw);

		//-------------------------------------------------------------------------------------------

		let feRank = this.weightVin * this.rankVin + this.weightIo * this.rankIo + this.weightFsw * this.rankFsw;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightVin - this.weightIo - this.weightFsw) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
